import { useThree } from '@react-three/fiber';
import { useEffect } from 'react';
import * as THREE from 'three';
import LabeledAxes from './LabeledAxes';
import MeasurementLine from './MeasurementLine';
import { SceneProps } from './types';

export function Scene({
  modelDataUrl: modelUrl,
  showAxes = false,
  handleClick,
  isLoading,
  measureMode,
  measurePoints,
}: SceneProps) {
  const { scene } = useThree();

  // Setup lighting
  useEffect(() => {
    console.log('[Scene] Setting up lighting');
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
    directionalLight.position.set(5, 5, 5);
    directionalLight.castShadow = true;

    directionalLight.shadow.mapSize.width = 1024;
    directionalLight.shadow.mapSize.height = 1024;
    directionalLight.shadow.camera.near = 0.1;
    directionalLight.shadow.camera.far = 100;
    directionalLight.shadow.bias = -0.001;

    scene.add(ambientLight);
    scene.add(directionalLight);

    console.log('[Scene] Scene setup complete:', {
      children: scene.children.length,
      lights: scene.children.filter(child => child instanceof THREE.Light).length,
      camera: scene.getObjectByName('camera')?.type,
    });

    return () => {
      scene.remove(ambientLight);
      scene.remove(directionalLight);
    };
  }, [scene]);

  return (
    <group onClick={handleClick}>
      {/* Loading state */}
      {isLoading && (
        <mesh>
          <sphereGeometry args={[1, 16, 16]} />
          <meshBasicMaterial color="#cccccc" wireframe />
        </mesh>
      )}

      {/* Axes and Measurements */}
      {showAxes && <LabeledAxes />}
      {measurePoints.length > 0 && (
        <MeasurementLine points={measurePoints} hovering={measureMode} />
      )}
    </group>
  );
}
